import { Component } from 'react';
import type { ReactNode, ErrorInfo } from 'react';

type BlockErrorBoundaryProps = {
  children: ReactNode;
  /** 自定义 fallback，默认渲染一个轻量占位提示 */
  fallback?: ReactNode;
};

type BlockErrorBoundaryState = {
  hasError: boolean;
};

/**
 * BlockErrorBoundary — 轻量 Error Boundary
 *
 * 用于包裹单个渲染块（block），捕获渲染期异常，
 * 防止局部渲染错误导致整个面板白屏。
 */
export class BlockErrorBoundary extends Component<BlockErrorBoundaryProps, BlockErrorBoundaryState> {
  constructor(props: BlockErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): BlockErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[BlockErrorBoundary] Render error:', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div className="flex items-center justify-center py-3 text-[13px] text-[#A3A3A3]">Content unavailable</div>
        )
      );
    }
    return this.props.children;
  }
}
